import { render, staticRenderFns } from "./publish-page.vue?vue&type=template&id=38c58750&scoped=true&"
import script from "./publish-page.vue?vue&type=script&lang=js&"
export * from "./publish-page.vue?vue&type=script&lang=js&"
import style0 from "./publish-page.vue?vue&type=style&index=0&id=38c58750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c58750",
  null
  
)

component.options.__file = "publish-page.vue"
export default component.exports